import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  InsuranceCaseSortColumn,
  SortOrder,
  InsuranceCaseStatus,
} from 'api/insurance'
import { RootState } from 'appHooks'
import { IPaginationModel } from 'shared/models/List'

export type InsuranceCasesListFilters = IPaginationModel & {
  searchText: string
  sortOrder: SortOrder
  sortColumn: InsuranceCaseSortColumn
  status: InsuranceCaseStatus
}

// The list was re-sorted by date client-side before, so this keeps the order
// it has always opened in — now as a query the sort controls can change.
export const insuranceCasesInitialFilters: InsuranceCasesListFilters = {
  status: InsuranceCaseStatus.Active,
  searchText: null,
  sortColumn: InsuranceCaseSortColumn.CaseDate,
  sortOrder: SortOrder.Descending,
  take: 10,
  skip: 0,
}

const insuranceCasesFiltersSlice = createSlice({
  name: 'insuranceCasesFilters',
  initialState: insuranceCasesInitialFilters,
  reducers: {
    patchInsuranceCasesFilters: (
      state,
      action: PayloadAction<Partial<InsuranceCasesListFilters>>
    ) => ({ ...state, ...action.payload }),
    resetInsuranceCasesFilters: () => insuranceCasesInitialFilters,
  },
})

export const getInsuranceCasesFilters = (state: RootState) =>
  state.insuranceCasesFilters

export const { patchInsuranceCasesFilters, resetInsuranceCasesFilters } =
  insuranceCasesFiltersSlice.actions

export default insuranceCasesFiltersSlice
